import {
  Directive,
  ElementRef,
  forwardRef,
  HostListener
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[unhTextareaAcessor]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaAcessorDirective),
      multi: true
    }
  ]
})
export class TextareaAcessorDirective implements ControlValueAccessor {

  editor: any;

  @HostListener('editorCreated', ['$event.detail'])
  listenForValueChange(editor) {
    this.editor = editor;
    editor.on('text-change', (e) => {
        this.value = editor.root.innerHTML;
    });
  }

  constructor(
  ){ }

  onChange: any = () => { };
  onTouched: any = () => { };

  private _value: number;

  get value() {
    return this._value;
  }

  set value(val) {
    if (val !== this._value) {
      this._value = val;
      this.onChange(this._value);
      this.onTouched();
    }
  }

  writeValue(value) {
    if (this.editor) {
        this.editor.disable();
        this.editor.setText('')
        this.editor.clipboard.dangerouslyPasteHTML(0, '');
        this.editor.clipboard.dangerouslyPasteHTML(0, value);
        this.editor.enable();
      }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

}

